"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/ParticipantsBoard/Participant.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _SoundAmplitude = require('web/components/VideoCall/SoundAmplitude'); var _SoundAmplitude2 = _interopRequireDefault(_SoundAmplitude);
var _AudioFeed = require('web/components/VideoCall/AudioFeed'); var _AudioFeed2 = _interopRequireDefault(_AudioFeed);
var _VideoFeed = require('web/components/VideoCall/VideoFeed'); var _VideoFeed2 = _interopRequireDefault(_VideoFeed);
var _Spinner = require('web/components/Spinner'); var _Spinner2 = _interopRequireDefault(_Spinner);
var _videoCall = require('web/services/videoCall');
var _Tooltip = require('web/components/Tooltip');

const noop = () => { /* no-op */ }















// A MediaStream per instance, created once (the class fields).
const useInstanceStream = () => {
  const stream = _react.useRef(null)
  if (stream.current === null) stream.current = new MediaStream()
  // SAFETY: set on the line above, and only ever replaced with another stream.
  return stream 
}

// Was a plain class component (no memo, as before). The audio and video
// MediaStreams are instance fields: VideoFeed/AudioFeed (VideoFeed is memo'd)
// keep the same stream object across re-renders, so the <video>/<audio>
// elements are not re-attached. A stream is replaced only when its track
// changes, and then the tile re-renders once (forceUpdate), as before.
// Mount/update/unmount work runs in layout effects, after the feeds' own ref
// callbacks, which is the class order.
const Participant = ({
  name, isScreenParticipant,
  isMe, isActive,
  audioTrack, videoTrack,
  isLoading,
  problemCode,
  participantKey, onParticipantPick,
}) => {
  const audioStream = useInstanceStream()
  const videoStream = useInstanceStream()
  const [, forceUpdate] = _react.useReducer.call(void 0, (n) => n + 1, 0)
  const prevTracks = _react.useRef(null)

  const handleParticipantPick = () => onParticipantPick(participantKey)

  // componentDidMount (first run) / componentDidUpdate. The class compared the
  // tracks after every update; running only when one changed is the same.
  _react.useLayoutEffect.call(void 0, () => {
    const prev = prevTracks.current
    prevTracks.current = { audioTrack, videoTrack }

    if (!prev) {
      if (audioTrack) audioStream.current.addTrack(audioTrack)
      if (videoTrack) videoStream.current.addTrack(videoTrack)
      return
    }

    if (audioTrack && audioTrack !== prev.audioTrack) {
      audioStream.current.getTracks().forEach(t => audioStream.current.removeTrack(t))
      audioStream.current = new MediaStream([audioTrack])
      forceUpdate()
    }
    if (videoTrack && videoTrack !== prev.videoTrack) {
      videoStream.current.getTracks().forEach(t => videoStream.current.removeTrack(t))
      videoStream.current = new MediaStream([videoTrack])
      forceUpdate()
    }
  }, [audioTrack, videoTrack, audioStream, videoStream])

  // componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => () => [audioStream.current, videoStream.current]
    .forEach(s =>
      s.getTracks().forEach(t => s.removeTrack(t)),
    ), [audioStream, videoStream])

  const participantClassName = _classBuilder2.default.call(void 0, 
    "video-call--participant",
    { active: isActive },
  )

  const feedWrapperClassName = _classBuilder2.default.call(void 0, 
    "video-call--participant-feed-wrapper",
    { 'audio-only': !videoTrack },
  )

  const issueTooltipContent = (
    _react2.default.createElement(_Tooltip.TooltipContent, { className: "video-call--participant--problem-tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
      /* Only rendered for a network problem, so the code is set. */
      ,  _videoCall.formatDisplayErrorMessage.call(void 0, name, problemCode, isMe) 
    )
  )

  return (
    _react2.default.createElement('div', {
      className: participantClassName,
      onClick: isLoading ? noop : handleParticipantPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}

      , _react2.default.createElement('div', { className: feedWrapperClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
        ,  !videoTrack && !isLoading &&
          _react2.default.createElement('img', {
            className: "video-call--participant-feed-stub",
            src: "/assets/icons/video/speaker.svg",
            alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
          )
        
        ,  isLoading &&
          _react2.default.createElement(_Spinner2.default, {
            className: "video-call--participant-feed-stub--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}
          )
        
        , _react2.default.createElement(_VideoFeed2.default, {
          isCover: true,
          shouldMirror: isMe && !isScreenParticipant && _videoCall.shouldMirrorCamFeed.call(void 0, videoTrack),
          wrapperClassName: "video-call--participant-feed",
          stream: videoStream.current, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
        )
        ,  !isMe && _react2.default.createElement(_AudioFeed2.default, { stream: audioStream.current, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} )
      )
      , _react2.default.createElement('div', { className: "video-call--participant-summary", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
        ,  problemCode === _videoCall.problemCodes.NETWORK &&
          _react2.default.createElement(_Tooltip.HoverTooltip, { place: "top", type: "dark", content: issueTooltipContent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
            , _react2.default.createElement('div', { className: "video-call--participant-problem", __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}} )
          )
        
        , _react2.default.createElement('span', { className: "video-call--participant-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
          ,  isScreenParticipant ? `[Screen] ${name}` : name 
        )
        ,  isLoading
          ? null
          : audioTrack
            ? _react2.default.createElement(_SoundAmplitude2.default, {
                className: "video-call--participant-sound-amp",
                audioTrack: audioTrack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
              )
            : _react2.default.createElement('div', { className: "video-call--participant-mic-warn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
                , _react2.default.createElement('img', {
                  src: "/assets/icons/video/mic-off-white-no-outline.svg",
                  alt: "🔇", __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
                )
              )
        
      )
    )
  )
}

exports. default = Participant
